module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/pins/core-97d4ca967156cddf41b903254968831f.svg";